import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _MainMenu;
import { MainMenuProvider } from "./context";
import MainMenu from "./MainMenu";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * @deprecated
 *
 * This is a legacy component used for organizations that are not centralized yet.
 */
var MainMenuWithContext = function MainMenuWithContext(mainMenuProps) {
  return /*#__PURE__*/_jsx(MainMenuProvider, _objectSpread(_objectSpread({
    variant: "default"
  }, mainMenuProps), {}, {
    children: _MainMenu || (_MainMenu = /*#__PURE__*/_jsx(MainMenu, {}))
  }));
};
export default MainMenuWithContext;